
import { Component, Vue } from 'nuxt-property-decorator'
@Component({})
export default class extends Vue {
  head () {
    return {
      title: this.$t('head.title.how-to-use'),
      meta: [
        { hid: 'og:title', name: 'og:title', content: this.$t('head.title.how-to-use') },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }
}
